<div class="container">
  @if (imageUrl()) {
    <img alt="Template Preview Image" src="{{ imageUrl() }}" width="100%" height="auto" />
  } @else {
    <img alt="Template Preview Image" src="{{ placeholderImgSrc }}" width="100%" height="auto" />
  }
</div>
